import { useEffect, useRef } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
const mediaQuery = [{ screen: '(min-width: 280px)', width: '294px' }]
export default function CorrectAnswerScreen(): React.ReactElement {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let timeoutShow: NodeJS.Timeout
    let timeoutHide: NodeJS.Timeout

    if (ref.current) {
      timeoutShow = setTimeout(() => {
        ref.current?.classList.add('opacity-0')
      }, 800)

      timeoutHide = setTimeout(() => {
        ref.current?.classList.remove('opacity-0')
      }, 10)
    }

    return () => {
      clearTimeout(timeoutShow)
      clearTimeout(timeoutHide)
    }
  }, [])

  return (
    <div
      className="absolute opacity-0 inset-0 z-30 flex items-center justify-center rounded bg-green-light-deep/40 transition pointer-events-none"
      ref={ref}
    >
      <div className="relative">
        <ResponsiveImage
          height={250}
          imageWidths="294"
          mediaQuery={mediaQuery}
          srcKey="bootcamp/correct-checkmark.png"
          width={294}
        />
      </div>
    </div>
  )
}
